/**
 * "N days" with the Arabic counted noun in the right form, so the trial copy
 * never reads "2 أيام" or "14 أيام".
 *
 *   1      -> يوم واحد
 *   2      -> يومين   (the form used after a preposition - "بعد يومين"،
 *                      "لمدة يومين" - and the natural spoken form)
 *   3-10   -> N أيام
 *   11-99  -> N يوماً
 *   100+   -> N يوم
 *
 * Sentences that use it are phrased so the count follows a preposition or a
 * colon ("لمدة :days"، "المتبقي: :days"), which keeps every form correct.
 */
export function arabicDayCount(count: number): string {
  const n = Math.max(0, Math.floor(count));

  if (n === 1) return 'يوم واحد';
  if (n === 2) return 'يومين';
  if (n >= 3 && n <= 10) return `${n} أيام`;
  if (n >= 11 && n <= 99) return `${n} يوماً`;
  return `${n} يوم`;
}
